import {useEffect, useState} from "react";
import {getAdminCmsHubCounts, listAdminClients, listAdminProducts} from "@zaaaz/shared";
import type {AdminSectionId} from "@/lib/adminSectionNav";

export function useAdminSectionBadges(section: AdminSectionId): Record<string, number> {
  const [badges, setBadges] = useState<Record<string, number>>({});

  useEffect(() => {
    if(section === "produse") {
      listAdminProducts({page: 1, pageSize: 1})
        .then((r) => {
          if(r.counts) {
            setBadges({
              pendingReviews: r.counts.pendingReviews,
              inactiveOffers: r.counts.inactiveOffers,
              shippingRules: r.counts.shippingRules
            });
          }
        })
        .catch(() => {});
      return;
    }
    if(section === "clienti") {
      listAdminClients({page: 1, pageSize: 1})
        .then((r) => {
          if(r.counts) {
            setBadges({
              groups: r.counts.groups,
              notifications: r.counts.notifications
            });
          }
        })
        .catch(() => {});
      return;
    }
    getAdminCmsHubCounts()
      .then((c) => setBadges({
        carousel: c.carousel,
        announcements: c.announcements,
        homeBoxes: c.homeBoxes,
        faq: c.faq
      }))
      .catch(() => {});
  }, [section]);

  return badges;
}
